import { render, staticRenderFns } from "./matchRecord.vue?vue&type=template&id=b3ac369a&scoped=true"
import script from "./matchRecord.vue?vue&type=script&lang=js"
export * from "./matchRecord.vue?vue&type=script&lang=js"
import style0 from "./matchRecord.vue?vue&type=style&index=0&id=b3ac369a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ac369a",
  null
  
)

export default component.exports